class PasswordCountdown extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.deadline);
    this.digits = this.querySelector('[data-countdown-digits]');
    this.units = ['days', 'hours', 'minutes', 'seconds'].map((unit) =>
      this.querySelector(`[data-countdown-unit="${unit}"]`),
    );
    if (!this.digits || this.units.some((unit) => !unit)) return;

    this.onVisibilityChange = () => this.resume();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.resume();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  resume() {
    clearInterval(this.timer);
    if (document.hidden) return;
    if (this.update()) this.timer = setInterval(() => this.update(), 1000);
  }

  update() {
    // Recalculate from the absolute deadline so throttled tabs never drift.
    const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
    if (!Number.isFinite(remaining) || remaining <= 0) {
      this.digits.hidden = true;
      clearInterval(this.timer);
      return false;
    }

    const values = [
      Math.floor(remaining / 86400),
      Math.floor((remaining % 86400) / 3600),
      Math.floor((remaining % 3600) / 60),
      remaining % 60,
    ];
    this.units.forEach((unit, index) => {
      unit.textContent = String(values[index]).padStart(2, '0');
    });
    this.digits.hidden = false;
    return true;
  }
}

if (!customElements.get('password-countdown')) {
  customElements.define('password-countdown', PasswordCountdown);
}
